const img1 = 'https://static.wixstatic.com/media/cda177_5b63fc47d8984bd094328cc5cf2045ef.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_5b63fc47d8984bd094328cc5cf2045ef.webp'
const img2 = 'https://static.wixstatic.com/media/cda177_467ce979b6924fe689b1347d7a982f3c.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_467ce979b6924fe689b1347d7a982f3c.webp'
const img3 = 'https://static.wixstatic.com/media/cda177_44a04a0dbe2e4fe09bcb0e99d933925f.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_44a04a0dbe2e4fe09bcb0e99d933925f.webp'
const img4 = 'https://static.wixstatic.com/media/cda177_95cd2230351d454e8fd76b7545766138.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_95cd2230351d454e8fd76b7545766138.webp'
const img5 = 'https://static.wixstatic.com/media/cda177_eb61b785ee834218a45a9fad11e1d19b.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_eb61b785ee834218a45a9fad11e1d19b.webp'
const img6 = 'https://static.wixstatic.com/media/cda177_f1f82c1c2f2f42df9e23af0c01bf10aa.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_f1f82c1c2f2f42df9e23af0c01bf10aa.webp'
const img7 = 'https://static.wixstatic.com/media/cda177_7459c231dd544be7ac7f6f5a1f379d76.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_7459c231dd544be7ac7f6f5a1f379d76.webp'
const img8 = 'https://static.wixstatic.com/media/cda177_1c16f70e659f4d0d9f48b5d2f4f211f2.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_1c16f70e659f4d0d9f48b5d2f4f211f2.webp'
const img9 = 'https://static.wixstatic.com/media/cda177_1fbd6bdcacca487d80040668c1e587f2.png/v1/fill/w_224,h_224,al_c,q_85,usm_0.66_1.00_0.01/cda177_1fbd6bdcacca487d80040668c1e587f2.webp'



const SaleProducts = [
    
    {
        id: 5,
        name: 'sale Five',
        images: [img5,img6],
        imageTwo: '',
        price: 343,
        priceTwo: 343,
        discretion: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat eligendi possimus porro veniam magnam nisi perspiciatis quas quasi et nobis!',
        color: ['Red'],
        size: 'large'
    },
    {
        id: 1,
        name: 'sale One',
        images: [img1,img2],
        price: 234,
        priceTwo: 343,
        discretion: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat eligendi possimus porro veniam magnam nisi perspiciatis quas quasi et nobis!',
        color: ['Green','Red'],
        size: 'medium'
    },
    {
        id: 2,
        name: 'sale two',
        images: [img2],
        price: 553,
        priceTwo: 454,
        discretion: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat eligendi possimus porro veniam magnam nisi perspiciatis quas quasi et nobis!',
        color: ['Brown','Black'],
        size: 'large'
    },
    {
        id: 3,
        name: 'sale three',
        images: [img3,img4],
        imageTwo: null,
        price: 135,
        priceTwo: 121,
        discretion: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat eligendi possimus porro veniam magnam nisi perspiciatis quas quasi et nobis!',
        color: ['Red'],
        size: 'large'
    },
    
    {
        id: 6,
        name: 'sale six',
        images: [img6,img7],
        price: 753,
        priceTwo: 345,
        discretion: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat eligendi possimus porro veniam magnam nisi perspiciatis quas quasi et nobis!',
        color: ['Purple'],
        size: 'small'
    },
    {
        id: 4,
        name: 'sale four',
        images: [img4,img5],
        imageTwo: '',
        price: 677,
        priceTwo: 257,
        discretion: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat eligendi possimus porro veniam magnam nisi perspiciatis quas quasi et nobis!',
        color: ['Black'],
        size: 'small'
    },
    {
        id: 7,
        name: 'sale seven',
        images: [img8,img9],
        price: 235,
        priceTwo: 212,
        discretion: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat eligendi possimus porro veniam magnam nisi perspiciatis quas quasi et nobis!',
        color: ['Red'],
        size: 'large'
    }

]

export default SaleProducts; 